<template>
    <div class="request-guide-modal">
        <ModalPattern class="absolute left-0 top-0 z-0" />

        <div class="header">
            <div class="icon-container">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M23.25 10.5H20.6325L16.1794 4.36781C16.0444 4.18253 15.8688 4.03065 15.666 3.92381C15.4632 3.81698 15.2387 3.75804 15.0095 3.75152C14.7804 3.745 14.5529 3.79108 14.3443 3.88621C14.1358 3.98135 13.9518 4.12301 13.8066 4.30031L12.6019 5.69719L12.5831 5.71875C12.5133 5.80644 12.4246 5.87726 12.3237 5.92594C12.2227 5.97461 12.1121 5.99989 12 5.99989C11.8879 5.99989 11.7773 5.97461 11.6763 5.92594C11.5754 5.87726 11.4867 5.80644 11.4169 5.71875L11.3981 5.69719L10.1934 4.30031C10.0482 4.12301 9.86422 3.98135 9.65568 3.88621C9.44714 3.79108 9.21958 3.745 8.99046 3.75152C8.76134 3.75804 8.53676 3.81698 8.33397 3.92381C8.13118 4.03065 7.95557 4.18253 7.82062 4.36781L3.3675 10.5H0.75C0.551088 10.5 0.360322 10.579 0.21967 10.7197C0.0790176 10.8603 0 11.0511 0 11.25C0 11.4489 0.0790176 11.6397 0.21967 11.7803C0.360322 11.921 0.551088 12 0.75 12H23.25C23.4489 12 23.6397 11.921 23.7803 11.7803C23.921 11.6397 24 11.4489 24 11.25C24 11.0511 23.921 10.8603 23.7803 10.7197C23.6397 10.579 23.4489 10.5 23.25 10.5ZM9.03187 5.25L9.04969 5.27156L10.2544 6.6675C10.4654 6.92693 10.7315 7.13607 11.0335 7.27971C11.3354 7.42336 11.6656 7.49789 12 7.49789C12.3344 7.49789 12.6646 7.42336 12.9665 7.27971C13.2685 7.13607 13.5346 6.92693 13.7456 6.6675L14.9503 5.27156C14.9559 5.26406 14.9597 5.2575 14.9662 5.25L18.7781 10.5H5.22094L9.03187 5.25ZM16.875 13.5C16.0449 13.5002 15.2441 13.8062 14.6254 14.3596C14.0068 14.9131 13.6138 15.6751 13.5216 16.5H10.4784C10.386 15.6758 9.99334 14.9146 9.37539 14.3614C8.75745 13.8083 7.95748 13.5021 7.12815 13.5012C6.29882 13.5003 5.49819 13.8048 4.87904 14.3565C4.25989 14.9083 3.86557 15.6687 3.77133 16.4927C3.67709 17.3166 3.88953 18.1465 4.3681 18.8238C4.84667 19.5011 5.55788 19.9785 6.36599 20.1649C7.17411 20.3512 8.02256 20.2336 8.74944 19.8343C9.47632 19.435 10.0307 18.782 10.3069 18H13.6931C13.8994 18.5834 14.262 19.0988 14.7414 19.49C15.2208 19.8811 15.7986 20.133 16.4115 20.218C17.0243 20.303 17.6488 20.2179 18.2166 19.972C18.7843 19.726 19.2736 19.3287 19.6308 18.8235C19.988 18.3183 20.1995 17.7246 20.2421 17.1073C20.2847 16.49 20.1568 15.8729 19.8723 15.3234C19.5879 14.7739 19.1578 14.3132 18.6292 13.9916C18.1006 13.6701 17.4937 13.5 16.875 13.5ZM7.125 18.75C6.75416 18.75 6.39165 18.64 6.08331 18.434C5.77496 18.228 5.53464 17.9351 5.39273 17.5925C5.25081 17.2499 5.21368 16.8729 5.28603 16.5092C5.35837 16.1455 5.53695 15.8114 5.79917 15.5492C6.0614 15.287 6.39549 15.1084 6.75921 15.036C7.12292 14.9637 7.49992 15.0008 7.84253 15.1427C8.18514 15.2846 8.47798 15.525 8.68401 15.8333C8.89003 16.1416 9 16.5042 9 16.875C9 17.1212 8.9515 17.365 8.85727 17.5925C8.76305 17.82 8.62494 18.0267 8.45082 18.2008C8.27672 18.3749 8.07002 18.513 7.84253 18.6073C7.61505 18.7015 7.37123 18.75 7.125 18.75ZM16.875 18.75C16.5042 18.75 16.1416 18.64 15.8333 18.434C15.525 18.228 15.2846 17.9351 15.1427 17.5925C15.0008 17.2499 14.9637 16.8729 15.036 16.5092C15.1084 16.1455 15.287 15.8114 15.5492 15.5492C15.8114 15.287 16.1455 15.1084 16.5092 15.036C16.8729 14.9637 17.2499 15.0008 17.5925 15.1427C17.9351 15.2846 18.228 15.525 18.434 15.8333C18.64 16.1416 18.75 16.5042 18.75 16.875C18.75 17.3723 18.5525 17.8492 18.2008 18.2008C17.8492 18.5525 17.3723 18.75 16.875 18.75Z" fill="#09090B"/>
                </svg>
            </div>

            <div class="title">
                <h4>Submit Research Request</h4>
                <p>Submit a research request, and we’ll look into it for you!</p>
            </div>
        </div>

        <div class="input-container">
            <label>Information</label>
            <prime-text-area rows="8" placeholder="Enter any information you have here..." v-model="info" />
        </div>

        <div class="actions-section">
            <prime-button class="p-btn-root_secondary" @click="closeDialog">Cancel</prime-button>
            <prime-button label="Submit" @click="submit" :disabled="info === ''" :loading="loader" />
        </div>
    </div>
</template>

<script setup lang="ts">
import ModalPattern from '~/assets/images/illustrations/modal-pattern.svg';
import { ModalNames } from '~/types/modals';

const loader = ref(false);
const info = ref('');
const { showSuccess, showError, showWarning } = useGlobalToast();
const dialogRef = getDialogRef(ModalNames.SUBMIT_RESEARCH_REQUEST);
const closeDialog = () => {
    dialogRef.value.close();
};

const submit = () => {
    loader.value = true;
    showSuccess('Success', 'Research Request Sent successfully');
    loader.value = false;
    closeDialog();
};
</script>

<style lang="scss" scoped>
.close-icon {
    @apply cursor-pointer p-1 rounded-full ;
}
.header {
    @apply relative z-10 flex flex-row gap-4 justify-start ;

    .icon-container {
        @apply flex w-12 h-12 p-3 justify-center items-center rounded-xl border border-gray-200 bg-white shadow-md ;
    }
    .title {
        h4 {
            @apply text-gray-900 text-lg font-semibold leading-7 ;
        }

        p {
            @apply text-gray-600 text-sm font-normal leading-5 ;
        }
    }
}
.request-guide-modal {
    @apply sm:max-w-xl sm:w-[440px] w-11/12 rounded-lg bg-white mx-auto h-auto overflow-y-auto p-6 relative;
}
.input-container {
    @apply flex flex-col gap-1 mt-5 relative z-10 ;
    label {
        @apply text-gray-700 text-sm font-medium leading-5 ;
    }
}
.actions-section {
    @apply flex gap-3 mt-8 justify-end relative z-10 ;
}
</style>
